import firebase, { auth, functions } from 'firebase/app'

import * as marketService from '../services/markets'
import * as transactionService from '../services/transactions'
import { triggerRefundTransactions } from './transaction'

import { ROUTES, LIST_TYPE, IS_ADMIN } from '../constant'


export const addMarket = data => async (dispatch) => {
  dispatch({ type: 'LOADING' })

  try {
    const market = await marketService.addMarket(data)

    dispatch({ type: 'UNLOAD' })
    dispatch({
      type: 'SNACK_SUCCESS',
      snackUrl: `${ROUTES.MARKET}/${market.id}`,
      message: 'Commerce créé avec succès. Cliquez ici pour accéder à sa fiche.',
    })

    return true
  } catch (err) {
    dispatch({ type: 'UNLOAD' })
    dispatch({
      type: 'SNACK_ERROR',
      message: err.message,
    })

    return false
  }
}

export const triggerResetPassword = email => async (dispatch) => {
  dispatch({ type: 'LOADING' })

  try {
    await auth().sendPasswordResetEmail(email)

    dispatch({
      type: 'SNACK_SUCCESS',
      message: IS_ADMIN ? 'Un email a été envoyé à l\'utilisateur' : 'Un email vous a été envoyé pour réinitialiser le mot de passe.',
    })
  } catch (err) {
    console.error(err)

    dispatch({
      type: 'SNACK_ERROR',
      message: 'Impossible d\'envoyer l\'email de réinitialisation de mot de passe',
    })
  }

  dispatch({ type: 'UNLOAD' })
}

export const getMarket = uid => async (dispatch) => {
  dispatch({ type: 'GET_ITEM' })

  try {
    const market = await marketService.getMarket(uid)

    return dispatch({
      item: market,
      type: 'GET_ITEM_SUCCESS',
      itemType: LIST_TYPE.MARKETS,
    })
  } catch (err) {
    return dispatch({
      message: err.message,
      type: 'GET_ITEM_ERROR',
    })
  }
}

export const triggerToggleShop = shopId => async (dispatch) => {
  dispatch({ type: 'LOADING' })

  try {
    await functions().httpsCallable('triggerToggleShop')({ shopId })
    return dispatch(getMarket(shopId))
  } catch (err) {
    console.error(err)

    dispatch({
      type: 'SNACK_ERROR',
      message: 'Impossible de désactiver/réactiver le commerce',
    })
  }

  return dispatch({ type: 'UNLOAD' })
}

export const triggerSendQRCode = (shopId, base64) => async (dispatch) => {
  dispatch({ type: 'LOADING' })

  try {
    await functions().httpsCallable('triggerEmailQrCode')({ shopId, base64 })
    dispatch({
      type: 'SNACK_SUCCESS',
      message: 'Un e-mail vous a été envoyé avec le QR-Code.',
    })
  } catch (err) {
    console.error(err)

    dispatch({
      type: 'SNACK_ERROR',
      message: 'Une erreur est survenue pendant l\'envoie de votre QR-Code.',
    })
  }

  return dispatch({ type: 'UNLOAD' })
}


export const getMarketByUserId = () => async (dispatch) => {
  const user = firebase.auth().currentUser

  dispatch({ type: 'GET_ITEM' })

  try {
    const market = await marketService.getMarketByContactId(user.uid)

    return dispatch({
      item: market,
      type: 'GET_ITEM_SUCCESS',
      itemType: LIST_TYPE.MARKETS,
    })
  } catch (err) {
    return dispatch({
      message: err.message,
      type: 'GET_ITEM_ERROR',
    })
  }
}


export const getMarkets = (options = {}) => async (dispatch) => {
  dispatch({ type: 'GET_LIST' })

  try {
    const items = await marketService.getMarkets({
      orderBy: 'name',
      direction: 'asc',
      ...options,
    })

    return dispatch({
      items,
      type: 'GET_LIST_SUCCESS',
      listType: LIST_TYPE.MARKETS,
    })
  } catch (err) {
    return dispatch({
      message: err.message,
      type: 'GET_LIST_ERROR',
    })
  }
}


export const getMarketTransactions = (marketId, options) => async (dispatch, getState) => {
  dispatch({ type: 'LOADING' })

  try {
    const transactions = await transactionService.getTransactionsByMarket(marketId, options)

    return dispatch({
      type: 'GET_ITEM_SUCCESS',
      item: {
        ...getState().item,
        transactions,
      },
    })
  } catch (err) {
    return dispatch({
      type: 'SNACK_ERROR',
      message: err.message,
    })
  }
}


export const triggerRefundMarketTransactions = (shopId, transactionIds) => async (dispatch) => {
  await dispatch(triggerRefundTransactions(transactionIds))
  return dispatch(getMarketTransactions(shopId))
}


export const addQrcode = (marketId) => async (dispatch, getState) => {
  const { item } = getState()
  dispatch({ type: 'GET_ITEM' })

  try {
    const qrcode = await marketService.addQrcode(marketId)

    return dispatch({
      type: 'GET_ITEM_SUCCESS',
      itemType: LIST_TYPE.MARKETS,
      item: {
        ...item,
        qrcodes: (item.qrcodes || []).concat(qrcode),
      },
    })
  } catch (err) {
    return dispatch({
      message: err.message,
      type: 'GET_ITEM_ERROR',
    })
  }
}


export const editMarket = (marketId, values) => async (dispatch) => {
  dispatch({ type: 'LOADING' })

  try {
    await marketService.editMarket(marketId, values)

    return dispatch({
      type: 'SNACK_SUCCESS',
      message: 'Le commerce à bien été modifié',
    })
  } catch (err) {
    return dispatch({
      type: 'SNACK_ERROR',
      message: err.message,
    })
  }
}
